module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.back($event)
      }
    }
  }, ["返回"]), " ", _vm._h('h1', ["身高体重"]), " ", (_vm.studentId == 0) ? _vm._h('a', {
    staticClass: "pull-right icon-right icon-setup text-hide",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.popupVisibleScoreList = true
      }
    }
  }, ["发布"]) : _vm._e()]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadBottom),
      expression: "loadBottom"
    }],
    staticClass: "main-page bg-white",
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "infinite-scroll-disabled": "isGetting",
      "infinite-scroll-distance": "150"
    }
  }, [(_vm.studentId != 0 && _vm.scoreList.length == 0 && _vm.isGetting == false) ? _vm._h('div', {
    staticClass: "text-center mid-align vw100"
  }, [_vm._h('p', ["还没有添加该学生的身高体重哦！"])]) : _vm._e(), " ", (_vm.studentId == 0 && _vm.scoreList.length == 0 && _vm.isGetting == false) ? _vm._h('div', {
    staticClass: "text-center mid-align vw100"
  }, [_vm._h('p', ["还没有添加过学生身高体重哦！"])]) : _vm._e(), " ", _vm._h('div', {
    staticClass: "dynamic"
  }, [_vm._l((_vm.scoreList), function(score, index) {
    return _vm._h('div', [_vm._h('div', {
      staticClass: "padding-15 clearfix"
    }, [_vm._h('div', {
      staticClass: "pull-left left-part"
    }, [_vm._h('div', {
      staticClass: "img-wrap small"
    }, [_vm._h('img', {
      attrs: {
        "src": score.imageAddress ?
          _vm.baseAcessPath + score.imageAddress : _vm.img_default,
        "width": "100%"
      }
    })])]), " ", _vm._h('div', {
      staticClass: "right-part"
    }, [_vm._h('span', {
      staticClass: "font-16"
    }, [_vm._s(score.studentName)]), " ", _vm._h('div', {
      staticClass: "score clearfix gray"
    }, [_vm._h('div', {
      staticClass: "pull-left"
    }, ["身高：", _vm._h('cite', {
      staticClass: "red"
    }, [_vm._s(score.height) + " cm"])]), " ", _vm._h('div', {
      staticClass: "pull-left margin-x-15"
    }, ["体重：", _vm._h('cite', {
      staticClass: "red"
    }, [_vm._s(score.wight) + " kg"])])]), " ", _vm._h('div', {
      staticClass: "liner",
      staticStyle: {
        "margin": "10px 0"
      }
    }), " ", (score.field3) ? _vm._h('p', [_vm._s(score.field3)]) : _vm._e(), " ", _vm._h('ul', {
      staticClass: "block clearfix imgs"
    }, [_vm._l((score.picList), function(img, index) {
      return _vm._h('li', {
        staticClass: "col-xs-4"
      }, [_vm._h('div', {
        staticClass: "t-r-5"
      }, [_vm._h('div', {
        staticClass: "out-wrap"
      }, [_vm._h('span', {
        on: {
          "click": function($event) {
            _vm.showImgList(score.picList, index)
          }
        }
      }, [(img.thumbAddress) ? _vm._h('img', {
        staticClass: "mid-align",
        attrs: {
          "src": _vm.baseAcessPath + img.thumbAddress
        }
      }) : _vm._h('img', {
        staticClass: "mid-align",
        attrs: {
          "src": img.baseAcessPath + img.thumbAddress
        }
      }), " "])])])])
    })]), " ", _vm._h('div', {
      staticClass: "clearfix"
    }, [_vm._h('cite', {
      staticClass: "gray pull-left font-12"
    }, [_vm._s(score.growthDate)]), " ", (score.teacherId == _vm.teacherId) ? _vm._h('span', {
      staticClass: "pull-left margin-x-15 font-12",
      on: {
        "click": function($event) {
          _vm.delGrowthId = score.growthId, _vm.delGrowthIdIndex = index, _vm.isHideDelScore = false
        }
      }
    }, ["删除"]) : _vm._e(), " ", _vm._h('span', {
      staticClass: "pull-right  font-12"
    }, [_vm._s(score.teacherName) + "老师"])])])]), " ", _vm._h('div', {
      staticClass: "liner"
    })])
  })])])]), " ", _vm._h('mt-popup', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupVisibleScoreList),
      expression: "popupVisibleScoreList"
    }],
    attrs: {
      "position": "bottom"
    },
    domProps: {
      "value": (_vm.popupVisibleScoreList)
    },
    on: {
      "input": function($event) {
        _vm.popupVisibleScoreList = $event
      }
    }
  }, [_vm._h('div', {
    staticClass: "shall text-center"
  }, [_vm._h('div', {
    staticClass: "clearfix margin-15 font-12"
  }, [_vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('router-link', {
    staticClass: "icon-add icon gray",
    attrs: {
      "to": {
        'path': '/heightAndWeight/publish'
      }
    }
  }, ["新增一条"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('a', {
    staticClass: "icon-find icon gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideSelectStudent = false, _vm.popupVisibleScoreList = false
      }
    }
  }, ["查看TA的"])])]), " ", _vm._h('p', {
    staticClass: "gray margin-15 padding-15 font-12"
  }, ["坚持每个月给孩子量一次身高体重，记录孩子成长点滴的每一厘米，将来会成为您与孩子的宝贵财富，同时让家长知道，您在陪伴他还在的成长。"]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('span', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        _vm.popupVisibleScoreList = false
      }
    }
  }, ["取消"])])])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideDelScore),
      expression: "!isHideDelScore"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideDelScore = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [_vm._h('p', {
    staticClass: "margin-15"
  }, ["您确定要删除该条记录吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteGrowth()
      }
    }
  }, ["确定"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideDelScore = true
      }
    }
  }, ["取消"])])])])])]), " ", (_vm.isShowImgs) ? _vm._h('div', {
    staticClass: "maskdiv",
    staticStyle: {
      "background": "rgba(0,0,0,1)"
    },
    on: {
      "click": function($event) {
        _vm.isShowImgs = false
      }
    }
  }, [_vm._h('div', {
    staticClass: "imgs-box"
  }, [_vm._h('div', {
    staticClass: "swiper-container"
  }, [_vm._h('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l((_vm.imageList), function(item) {
    return _vm._h('div', {
      staticClass: "swiper-slide",
      staticStyle: {
        "height": "100vh"
      }
    }, [_vm._h('img', {
      staticClass: "swiper-lazy bigger-pic hide",
      attrs: {
        "data-src": _vm.baseAcessPath + item.imageAddress,
        "thumbImg": _vm.baseAcessPath + item.thumbAddress
      }
    }), " ", " "])
  })]), " ", " ", _vm._h('div', {
    staticClass: "swiper-pagination"
  })])])]) : _vm._e(), " ", " ", _vm._h('dialogStudents', {
    attrs: {
      "isHideSelectStudent": _vm.isHideSelectStudent,
      "studentFirstCharList": _vm.studentFirstCharList
    },
    on: {
      "close": _vm.closeDialogStudents,
      "selected": _vm.selectedStudent
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-235da9f7!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/heightAndWeight/HeightAndWeightList.vue
// module id = 187
// module chunks = 1